export const ROLES = {
  SUPER_ADMIN:       'super-admin',
  ADMIN:             'admin',
  IC_ADMIN:          'ic-admin',
  IC_UNDERWRITER:    'ic-underwriter',
  IC_CLAIMS_OFFICER: 'ic-claims-officer',
  IC_ACCOUNTANT:     'ic-accountant',
  IC_EXECUTIVE:      'ic-executive',
  IC_HR_MANAGER:     'ic-hr-manager',
  IC_CLIENT:         'ic-client',
  IC_AUDITOR:        'ic-auditor',
  IC_BROKER:         'ic-broker',
} as const;

/** Roles that must never appear in staff assignment UI */
export const NON_ASSIGNABLE_ROLES: string[] = [ROLES.IC_CLIENT, ROLES.IC_BROKER];

/**
 * Legacy role-based capability map for checks with no direct backend permission equivalent.
 * For most action checks, use backend permission keys (e.g. 'claim:assign', 'policy:approve')
 * directly with can() — those resolve from effectivePermissions returned at login.
 */
export const CAPABILITY_MAP: Record<string, string[]> = {
  // Platform-only — no backend permission equivalent
  change_subscription: [ROLES.IC_ADMIN],
  access_platform:     [ROLES.SUPER_ADMIN, ROLES.ADMIN],
  // Fine-grained actions with no backend permission string yet
  force_status:               [ROLES.IC_ADMIN],
  override_premium:           [ROLES.IC_ADMIN],
  transfer_recourse:          [ROLES.IC_ADMIN],
  decline_policy:             [ROLES.IC_ADMIN, ROLES.IC_UNDERWRITER],
  edit_litigation_financials: [ROLES.IC_ADMIN, ROLES.IC_ACCOUNTANT],
  add_litigation_doc:         [ROLES.IC_ADMIN, ROLES.IC_CLAIMS_OFFICER],
};
